<script setup>
import Header from "../Components/Layouts/App/Header.vue";
import Footer from "../Components/Layouts/App/Footer.vue";
import {provide, reactive} from "vue";

const props = defineProps({
    theme: String || null
});


const forceTheme = ['system', 'light', 'dark'].includes(props.theme) ? props.theme : null;

const state = reactive({
    theme: null
});

const isDarkPrefer = () => !!window.matchMedia('(prefers-color-scheme: dark)').matches;

const getTheme = () => {
    return state.theme;
}

const setTheme = (theme) => {
    state.theme = theme;
    localStorage.theme = state.theme;
    const meta = window?.document?.querySelector("meta[name=theme-color]");

    switch (state.theme) {
        case 'dark':
            document.documentElement.classList.add('dark')
            meta?.setAttribute('content', 'rgb(24, 25, 44)');
            break
        case 'light':
            document.documentElement.classList.remove('dark')
            meta?.setAttribute('content', '#ffffff');
            break
        case 'system':
            if (isDarkPrefer()) {
                document.documentElement.classList.add('dark');
                meta?.setAttribute('content', 'rgb(24, 25, 44)');
            } else {
                document.documentElement.classList.remove('dark')
                meta?.setAttribute('content', '#ffffff');
            }
            break;
    }
}

setTheme(forceTheme || localStorage.theme || 'system');

window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    if (getTheme() !== 'system') {
        return true;
    }

    setTheme('system');
})

provide('getTheme', getTheme);
provide('setTheme', setTheme);
</script>

<template>
    <Header>
        <template #subHeader>
            <slot name="subHeader"></slot>
        </template>
    </Header>
    <main class="flex-grow w-full pb-12 md:pb-16">
        <slot />
    </main>
    <Footer></Footer>
</template>

<style lang="scss">
.btn {
    @apply relative whitespace-nowrap block sm:inline-block outline-0 cursor-pointer z-0 rounded-[50px] -tracking-[1.28px] text-2xl md:text-[2rem];

    &:hover {
        .btn-hover-wrapper {
            @apply opacity-100 sm:w-full;
        }
    }

    &.inverse {
        @apply bg-[currentColor];

        .btn-text {
            @apply text-white;
        }

        .btn-hover-wrapper {
            .btn-hover {
                @apply bg-[white];

                span {
                    @apply text-[currentColor];
                }
            }
        }
    }

    &.submit {
        @apply bg-orange;

        .btn-text {
            @apply text-white border-0;
        }

        .btn-hover-wrapper {
            .btn-hover {
                @apply bg-blue-light border-0;

                span {
                    @apply text-white;
                }
            }
        }
    }

    .btn-text {
        @apply block text-center border-2 rounded-full text-[currentColor] py-4 sm:py-8 sm:px-32 font-extrabold;
        border-color: currentColor;
    }

    .btn-hover-wrapper {
        @apply absolute left-0 top-0 bottom-0 right-0 opacity-0 sm:opacity-100 sm:w-0 sm:right-auto overflow-hidden transition-all duration-300;

        .btn-hover {
            @apply absolute w-full sm:w-auto text-center left-0 top-0 bottom-0 block border-2 rounded-full py-4 sm:py-8 sm:px-32 font-extrabold;
            border-color: currentColor;
            background-color: currentColor;

            span {
                @apply text-white
            }
        }
    }
}
</style>
